import React from "react";
import { List, Card, Table, Col } from "antd";
import styled from 'styled-components';
import reduxCrud from "../redux";
import ActionBtns from "../../../components/ActionBtns/ActionBtns";
//import { getMaxListeners } from "cluster";
import { MrRow } from '../../../components/UI/MrTable/MrTable'

import { MrColumn } from '../../../components/UI/MrTable/MrTable';
import Mrcard from "../../../components/UI/MrTable/Mrcard";
import { Link } from "react-router-dom";




export const DisordersColumns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Abbreviation',
    dataIndex: 'abbreviation',
    key: 'abbreviation',
  },
  {
    title: 'Symptoms',
    dataIndex: 'symptoms',
    key: 'symptoms',
  },
  {
    title: 'Remarks',
    dataIndex: 'remarks',
    key: 'remarks',
  },
  {
    title: 'ActionBtns',
    dataIndex: 'actionBtns',
    key: 'actionBtns',
  },
];



 export const DisordersList = props => {
    const { item } = props
    console.log('props disorders---------->', props);
    var disordersId = `${"/u/disorders/" + props.item.id }` 
    const dataObject={
      Name:item.name,
      abbreviation:item.abbreviation,
      symptoms:item.symptoms,
      Remarks:item.remarks,
      ActionBtns:props.actionBtns,
      
    }
    console.log("dataobject", dataObject);
    return (        
      <Col span={24}  >

        <List.Item  >
          <MrRow className="desktop-only">
            <MrColumn style={{flex: 2}}> <Link to={disordersId}>{item.name} </Link>         </MrColumn>  
            <MrColumn style={{flex: 2}}> {item.abbreviation}  </MrColumn>  
            <MrColumn style={{flex: 2}}> {item.symptoms}      </MrColumn>
            <MrColumn style={{flex: 2}}> {item.remarks}       </MrColumn> 
            <MrColumn style={{flex: 2}}> {props.actionBtns}   </MrColumn>
          </MrRow>
          <Mrcard dataObject={dataObject}  />    
        </List.Item>
        
      </Col>  
    );
};
// export default DisordersList;